import { MapContainer, TileLayer, Marker } from "react-leaflet";
import * as L from "leaflet";
import * as S from "./styles";
import { lastLocationMarker } from "../../LastLocationsTab/LastLocationsMarker";
import { LatLngExpression } from "leaflet";
import { useEffect, useMemo, useRef } from "react";

// const LOADSCRIPT_KEY = "AIzaSyCyYIwYpE42g7zN-nVRrPKkAwRseyccpaM";

type PolicemanTabMapProps = {
  position: google.maps.LatLngLiteral;
};

export default function PolicemanTabMap({
  position,
}: PolicemanTabMapProps): JSX.Element {
  const mapRef = useRef<L.Map | null>(null);

  const positions: LatLngExpression = useMemo(
    () => [position.lat, position.lng],
    [position]
  );

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.panTo(new L.LatLng(position.lat, position.lng));
    }
  }, [position]);

  return (
    <S.MapContainer>
      <MapContainer
        className="map-container"
        center={positions}
        scrollWheelZoom
        zoom={17}
        ref={mapRef}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Marker position={positions} icon={lastLocationMarker()} />
      </MapContainer>
    </S.MapContainer>
  );
}
